module.exports = __webpack_public_path__ + "img/features-product.7485331.webp";